import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import RecoveryApp from './App';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import {BASE_URL} from './env.json';
import * as serviceWorker from './serviceWorker';

if (BASE_URL.startsWith('https://home.everaccountable.com/')) {
  console.log("sentry initiating")
  Sentry.init({
    dsn: "https://11409f032b564521ae9e36c8c1a2bfa4@o16112.ingest.sentry.io/5512881",
    integrations: [
      new Integrations.BrowserTracing(),
    ],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
};

ReactDOM.render(
  <React.StrictMode>
    <RecoveryApp className="RecoveryApp" />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
